export default "__VITE_ASSET__BNs1fWTN__"